<section class="about-section">
  <span #about class="visually-hidden"></span>
  <div class="width-wrapper">
    <h2 class="about-title">О компании</h2>
    <p class="about-epigraph">ООО «ТРЭВЕЛ ОФИС ПРО» создано и зарегистрировано 3 апреля 2019 года. Область деятельности предприятия - разработка компьютерного программного обеспечения.</p>

    <div class="about-wrapper" (wheel)="onWheel($event)" id="about-wrapper">
      <div *ngFor="let item of items" class="info-item">
        <p [class]="item.icon" class="info-title">{{item.title}}</p>
        <p [class]="item.info">{{item.company}}</p>
        <p class="info-text">{{item.text_before}}<span class="info-tsp">{{item.text}}</span>{{item.text_after}}</p>
        <p class="info-text"><b>{{item.text_bold1}}</b><br>{{item.text_dop1}}</p>
        <p class="info-text"><b>{{item.text_bold2}}</b><br>{{item.text_dop2}}</p>
        <p class="info-text"><b>{{item.text_bold3}}</b><br>{{item.text_dop3}}</p>
      </div>
      <div class="wrapper"></div>
    </div>
  </div>
</section>


